import React, { PureComponent } from "react";
import { toast } from "react-toastify";
import _ from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import { DropDown } from "../../Common/DropDown";
import { Icon } from "../../Common/Icon";
import { addNotificationReadFlag, hasNewNotifications } from "../../../helpers/notificationHelpers";
import { checkIsUserAuthorized, roles } from "../../../helpers/Authorization/authorizationHelpers";
import ManageNotificationCard from "./ManageNotificationCard";
import NoNotificationCard from "./NoNotificationCard";
import NotificationCard from "./NotificationCard";

class NotificationBell extends PureComponent {
  static propTypes = {
    isMobile: PropTypes.bool,
    notifications: PropTypes.array,
    userMetadata: PropTypes.object
  };

  static defaultProps = {
    isMobile: false,
    notifications: [],
    userMetadata: {}
  };

  state = {
    hasNewNotification: false,
    isNotificationDropdownOpen: false
  };

  componentDidMount() {
    document.body.addEventListener("click", this.handleCloseNotificationDropdown);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEmpty(this.props.notifications)) {
      const newNotifications = hasNewNotifications(this.props.notifications);
      this.handleSetNewNotification(newNotifications);
    }

    if (!prevState.hasNewNotification && this.state.hasNewNotification && !this.props.isMobile) {
      toast(i18n.t("notification.newNotification"), { type: toast.TYPE.INFO });
    }
  }

  componentWillUnmount() {
    document.body.removeEventListener("click", this.handleCloseNotificationDropdown);
  }

  handleSetNewNotification = hasNewNotification => this.setState({ hasNewNotification });

  handleCloseNotificationDropdown = () => this.setState({ isNotificationDropdownOpen: false });

  handleOpenNotificationDropdown = () => {
    addNotificationReadFlag(this.props.notifications);
    this.setState({ isNotificationDropdownOpen: true, hasNewNotification: false });
  };

  render() {
    const notifications = this.props.notifications.map(notification => (
      <NotificationCard notification={notification} key={notification.id} userMetadata={this.props.userMetadata} />
    ));
    if (_.isEmpty(notifications)) {
      notifications.push(<NoNotificationCard key="no-notification" />);
    }

    const footerComponent = checkIsUserAuthorized(roles.InternalExpert) ? ManageNotificationCard : null;

    return (
      <div className="notification-bell">
        <button onClick={this.handleOpenNotificationDropdown}>
          <Icon id="bell" className={classNames("notification-bell__icon", this.state.hasNewNotification && "--shake")} />
          {this.state.hasNewNotification && <figcaption className="notification-bell__indicator" />}
        </button>
        <DropDown
          className="dropdown notification-bell__dropdown"
          footer={{ component: footerComponent, height: 45 }}
          contentTag="menu"
          maxHeight={500}
          isOpen={this.state.isNotificationDropdownOpen}>
          {notifications}
        </DropDown>
      </div>
    );
  }
}

export default NotificationBell;



// WEBPACK FOOTER //
// ./src/components/Layout/Notifications/NotificationBell.js